import React, { useState, useEffect } from "react";
import Button from "../UIComponents/Button";
import { useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";
import { persistor } from "../../redux/app/store";
import { useDispatch } from "react-redux";
import LogoutModal from "../../Dashboard/Modals/LogoutModal";

const ProfileDrop = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("wealth_user"))?.data
  );

  const logoutHandler = () => {
    setShowLogoutModal(true);
    // localStorage.clear();
    // dispatch({ type: "RESET_STORE" });
    // persistor.purge();
    // navigate("/login");
  };
  return (
    <>
      <LogoutModal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        showCloseIcon={true}
      />
      <div className="navbar-profile-drop-wrapper">
        <div className="navbar-profile-drop-wrap">
          <div className="profile-nav-item-repeat">
            <img src="./images/icons/user-icon.png" alt="icon" />
            <p> {user?.fullName ? user?.fullName : "--"}</p>
          </div>

          <div className="profile-nav-item-repeat">
            <img src="./images/icons/user-icon.png" alt="icon" />
            <p> {user?.email ? user?.email : "--"} </p>
          </div>

          <div className="logut-button-wrap">
            <Button
              onClick={logoutHandler}
              extraClass="logout-button"
              label="Logout"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileDrop;
